export const claimStatusListAction = (payload) => {
  return {
    type: "REQ_CLAIM_STATUS",
    payload,
  };
};

export const claimStatusResetAction = (payload) => {
  return {
    type: "RESET",
    payload,
  };
};
